import {Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Home from './pages/Home';
import Register from './pages/auth/Register'; 
import Login from './pages/auth/Login';
import axios from 'axios';
import About from './pages/About';
import Contact from './pages/Contact';
import AdminPrivateRoute from './AdminPrivateRoute';
// frontend/collections routes
import ListCategories from './_modules/public/homepage/ListCategories';
import CategoriesProducts from './_modules/public/collections/CategoriesProducts';

import ProductDetail from './_modules/public/collections/ProductDetail';
import Cart from './_modules/public/Cart';
import Checkout from './_modules/public/Checkout';
import Categories from './_modules/public/collections/Categories';
import Thankyou from './_modules/public/Thankyou';
import { Helmet } from 'react-helmet-async';
import swal from 'sweetalert';
import { useEffect, useState, useCallback, useRef } from 'react';
import Products from './pages/Products';
import Products1 from './pages/Products1';
import Products2 from './pages/Products2';
import Products3 from './pages/Products3';

axios.defaults.baseURL =
  process.env.NODE_ENV === "production"
    ? "https://api.ecommerce.com"
    : "http://localhost:8000";

export const API_BASE_URL = axios.defaults.baseURL;

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Accept'] = 'application/json';

axios.defaults.withCredentials = true;
axios.interceptors.request.use(function (config){
  const token = localStorage.getItem('auth_token');
  config.headers.Authorization = token ? `Bearer ${token}` : ``;
  return config;
});

const Main = () => {
  const company = 'MIPAT - Modern Integrated Farms and Food Processing Ltd';
  const navigate = useNavigate();
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  
  const INACTIVITY_TIMEOUT_MS = 900000 // 15 minutes of inactivity
  
//const INACTIVITY_TIMEOUT_MS = 30000; // 30 seconds for testing
  
  // FIX: Use useRef for mutable values like timeout IDs
  const timeoutIdRef = useRef(null); 

  // Use useCallback to memoize the handleLogout function
  const handleLogout = useCallback(() => {
    if (localStorage.getItem('auth_token')) {
      // Clear tokens from localStorage
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_name');

      swal('Session Timeout', 'You were automatically logged out due to inactivity.', 'info');
      navigate('/login'); // Redirect after logout
    }
  }, [navigate]); // navigate is the only dependency here!

  // Use useCallback to memoize the resetTimer function
  const resetTimer = useCallback(() => {
    clearTimeout(timeoutIdRef.current);
    if (localStorage.getItem('auth_token')) {
      // Assign new timeout ID to timeoutIdRef.current
      timeoutIdRef.current = setTimeout(handleLogout, INACTIVITY_TIMEOUT_MS);
    }
  }, [handleLogout, INACTIVITY_TIMEOUT_MS]); // Only dependencies are functions/constants

  // 1. GLOBAL AUTH CHECK EFFECT (No changes needed here)
  useEffect(() => {
    let isMounted = true;
      if (localStorage.getItem('auth_token')) {
        axios.get('/api/checkingAuthenticated') 
          .then(res => {
            if (isMounted && res.data.status !== 200) {
              localStorage.removeItem('auth_token');
              localStorage.removeItem('auth_name');
            }
          })
          .catch(error => {
            if (isMounted && error.response && (error.response.status === 401 || error.response.status === 403)) {
              localStorage.removeItem('auth_token');
              localStorage.removeItem('auth_name');
            }
          })
          .finally(() => {
            if (isMounted) setIsAuthChecked(true);
          });
        } else {
          setIsAuthChecked(true);
        }

      return () => { isMounted = false; };
  }, []); 
 
  // 2. INACTIVITY LISTENER EFFECT
  useEffect(() => {
    // Start the timer when component mounts
    resetTimer();

    // Listen for activity events to reset the timer
    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keypress', resetTimer);
    window.addEventListener('scroll', resetTimer);
    window.addEventListener('click', resetTimer);

    // Clean up listeners when component unmounts
    return () => {
      // Use timeoutIdRef.current for cleanup
      clearTimeout(timeoutIdRef.current); 
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keypress', resetTimer);
      window.removeEventListener('scroll', resetTimer);
      window.removeEventListener('click', resetTimer);
    };
  }, [resetTimer]); 

  // CONDITIONAL RETURN 
  if (!isAuthChecked) {
    return <div className="text-center py-5">Checking Session...</div>; 
  }

  // 3. Main Component Return (Runs only when isAuthChecked is true)
  return (
      <>
      <Helmet>
          <link rel="icon" href="/img/core-img/favicon.ico" />
          <link rel="stylesheet" href="/css/core-style.css" />
          <link rel="stylesheet" href="/style.css" />
          <link href="/css/responsive.css" rel="stylesheet" />
          <link rel="stylesheet" href="/css/custom.css" />
          <script src="/js/bootstrap.min.js"></script>
      </Helmet>

      <Routes>
        <Route path="" element={<Home company={company} />} />
        
        <Route
            path="/login"
            element={
                localStorage.getItem('auth_token')
                    ? <Navigate to="/" />
                    : <Login />
            }
        />

        <Route
            path="/register"
            element={
                localStorage.getItem('auth_token')
                    ? <Navigate to="/" />
                    : <Register />
            }
        />

        <Route path="/admin/*" element={<AdminPrivateRoute />} />

        <Route path="/about" element={<About company={company} />} />
        <Route path="/products" element={<Products />} />
        
        <Route path="/products/spillclean-powder" element={<Products1 />} />
        <Route path="/products/fertilizer-and-water-mixing-machine" element={<Products2 />} />
        <Route path="/products/cocopeat-and-coconut-husk-chips" element={<Products3 />} />

        <Route path="/contact" element={<Contact />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />

        {/* Frontend/Homepage */}
        <Route path="/list-categories" element={<ListCategories />} />

        <Route path="/collections" element={<Categories />} />
        <Route path="/collections/:slug" element={<CategoriesProducts />} />
        <Route path="/collections/:slug_categ/:slug_prod" element={<ProductDetail />} />
        <Route path="/thank-you" element={<Thankyou company={company} />} />
      </Routes>
    </>
  );
}
export default Main;